
export enum GoalTypeCd {
	LINEHAUL = 'Linehaul',
	PN_D = 'PnD'}

